import {defineMessages} from 'react-intl'
import {BRAND_KEY} from '../../brand'

const isKenwood = BRAND_KEY === 'kenwood'
const isBraun = BRAND_KEY === 'braun'

const deliveryLabels = defineMessages({
    kenwood: {
        defaultMessage: 'Free delivery in 1-3 days ',
        id: 'shipping_services.label.free_delivery.kenwood',
    },
    braun: {
        defaultMessage: 'Free delivery in 1-3 days ',
        id: 'shipping_services.label.free_delivery.braun',
    },
    otherBrands: {
        defaultMessage: 'Free delivery in 1-3 days ',
        id: 'shipping_services.label.free_delivery',
    },
})
const deliveryBlackLabels = defineMessages({
    kenwood: {
        defaultMessage: 'over 25€ ',
        id: 'shipping_services.label.free_delivery.kenwood.black',
    },
    braun: {
        defaultMessage: 'over 25€ ',
        id: 'shipping_services.label.free_delivery.braun.black',
    },
    otherBrands: {
        defaultMessage: 'over 30€ ',
        id: 'shipping_services.label.free_delivery.black',
    },
})
const deliveryStrongText = isKenwood
    ? deliveryLabels.kenwood
    : isBraun
    ? deliveryLabels.braun
    : deliveryLabels.otherBrands
const deliveryNormalText = isKenwood
    ? deliveryBlackLabels.kenwood
    : isBraun
    ? deliveryBlackLabels.braun
    : deliveryBlackLabels.otherBrands

export const delivery = {
    id: 'delivery',
    strongText: deliveryStrongText,
    normalText: deliveryNormalText,
    infoPopover: {
        title: {
            id: 'shipping_services.info.popover.free_delivery.title',
            defaultMessage: 'Delivery',
        },
        description: {
            id: 'shipping_services.info.popover.free_delivery.description',
            defaultMessage: 'Free delivery in 1-3 days',
        },
    },
}

export const returns = {
    id: 'returns',
    strongText: {
        id: 'shipping_services.label.free_returns',
        defaultMessage: 'Free return',
    },
    normalText: {
        id: 'shipping_services.label.free_returns.black',
        defaultMessage: 'up to 30 days',
    },
    infoPopover: {
        title: {
            id: 'shipping_services.info.popover.free_returns.title',
            defaultMessage: 'Return',
        },
        description: {
            id: 'shipping_services.info.popover.free_returns.description',
            defaultMessage: 'Return Description',
        },
    },
}

export const garanzia = {
    id: 'garanzia',
    strongText: {
        id: 'shipping_services.label.garanzia',
        defaultMessage: '3 Year',
    },
    normalText: {
        id: 'shipping_services.label.garanzia.black',
        defaultMessage: 'Warranty',
    },
    urlLink: {
        id: 'shipping_services.label.garanzia.link',
        defaultMessage: '',
    },
    infoPopover: {
        title: {
            id: 'shipping_services.info.popover.garanzia.title',
            defaultMessage: 'Guarantee',
        },
        description: {
            id: 'shipping_services.info.popover.garanzia.description',
            defaultMessage: 'Guarantee Description',
        },
    },
}
